// components/LoginPage.js

import React from 'react';
import LoginForm from '../Forms/LoginForm';
import logo from '../../assets/budgit_logo.png';

const LoginPage = () => {
  return (
    <div className="rego-login-page-content">
      <div className="page-content-container">
        <img src={logo} alt="Budgit Logo" className="rego-login-logo" />
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;
